
/**
 * Export markdown files.
 */

import en from 'client/markdown/en';
import pt from 'client/markdown/pt';

/**
 * Export `legal` markdown content.
 */

export const legal = {
  en,
  pt
};



// WEBPACK FOOTER //
// ../src/client/markdown/index.js